const enrollmentStatusLabel: Record<string, string> = {
  confirmed: "Confirmada",
  pending: "Pendente",
  needs_info: "Aguardando informação",
  cancelled: "Cancelada",
};

const paymentStatusLabel: Record<string, string> = {
  paid: "Pago",
  pending: "Pendente",
  invalidated: "Invalidado",
  not_applicable: "Não se aplica",
};

export const translateEnrollmentStatus = (status: string) => enrollmentStatusLabel[status] ?? status;
export const translatePaymentStatus = (status: string, requiresPayment = false) => {
  if (requiresPayment && (status === "pending" || status === "not_applicable")) return "Não realizado";
  return paymentStatusLabel[status] ?? status;
};
